import { defineMessages } from 'react-intl';

// `previewPdf` and `download` carry no `description` so their generated ids
// keep matching already-translated catalog entries.
export const artefactBlockMessages = defineMessages({
  previewPdf: {
    defaultMessage: 'Preview PDF',
    id: 'Cxut/QTb5o',
  },
  previewSpreadsheet: {
    defaultMessage: 'Preview spreadsheet',
    id: 'rXyb+fzGO1',
    description: 'Action label on a generated CSV/Excel artefact card in chat',
  },
  previewPresentation: {
    defaultMessage: 'Preview presentation',
    id: 'G5ZgOJQbjs',
    description: 'Action label on a generated presentation artefact card in chat',
  },
  downloadDocument: {
    defaultMessage: 'Download document',
    id: 'N9lZkOEJLc',
    description: 'Action label on a generated Word document artefact card in chat',
  },
  download: {
    defaultMessage: 'Download',
    id: '5q3qC0sC3r',
  },
  generatingPdf: {
    defaultMessage: 'Generating PDF',
    id: 'HlFJyOz1Rs',
    description: 'Progress caption while a PDF artefact is being generated in chat',
  },
  generatingPatientHandout: {
    defaultMessage: 'Generating patient handout',
    id: 'VnaZYM3AG+',
    description:
      'Progress caption while a patient handout artefact is being generated in chat',
  },
  fillingPdfForm: {
    defaultMessage: 'Filling PDF form',
    id: 'PjhXxCmt42',
    description: 'Progress caption while a PDF form is being filled in chat',
  },
  generatingDocument: {
    defaultMessage: 'Generating document',
    id: '2RogdRm6NB',
    description:
      'Progress caption while a Word document artefact is being generated in chat',
  },
  generatingCsv: {
    defaultMessage: 'Generating CSV',
    id: 'dmPXnUoXoy',
    description: 'Progress caption while a CSV artefact is being generated in chat',
  },
  generatingSpreadsheet: {
    defaultMessage: 'Generating spreadsheet',
    id: 'hb7bb+CyEj',
    description:
      'Progress caption while a spreadsheet artefact is being generated in chat',
  },
  generatingPresentation: {
    defaultMessage: 'Generating presentation',
    id: 'dT7IkbFjUc',
    description:
      'Progress caption while a presentation artefact is being generated in chat',
  },
  generating: {
    defaultMessage: 'Generating',
    id: 'OFtoHNanmg',
    description: 'Generic progress caption while an artefact is being generated in chat',
  },
  generationFailed: {
    defaultMessage: 'Generation failed',
    id: 'ssRq8DsBq1',
  },
});
